import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import $ from 'jquery';
import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';

import { PartSelection } from '@/components/families/ori/Ori9';
import  { Carousel3d, Slide }  from 'vue-carousel-3d' ;
import { AccordionMenu } from 'vue-accordion-menu';
import AccList from '@/components/acc-list/AccList';


@Component({
  components: {
    accMenu: AccList,
    carousel: Carousel3d ,
    slide: Slide,
  },
})

export default class PartsColor extends Vue {
  @Prop()
  product: ProductDefinition;

  selectedPart: string = null;
  selectedColor: any = null;
  selectedPallate: any = null;

  created() {
    this.selectedPart = this.product.partsPalettes[0].part;
  }

  onAfterSlideChange(index: number) {
    const plattes = this.product.partsPalettes[index];
    this.partChanged(plattes.part);
    const prevFaqQuestion = this.$el.querySelectorAll('.faq-question');
    if (prevFaqQuestion.length !== 0) {
      const frameZones = Array.from(this.$el.querySelectorAll('.faq-question'));
      frameZones.forEach((element) => {
        const con2 =   element.querySelectorAll('.faq-content')[0] as any;
        element.classList.remove('open');
        con2.style.display = 'none';
      });
    }
  }

  partChanged(part) {
    this.selectedPart = part;
  }

  colorChanged() {
    if (!this.selectedColor) {
      return;
    }
    this.$emit('colorChanged',this.selectedColor,this.selectedPallate,this.selectedPart);
  }

  isReady: boolean = false;
  mounted() {
    this.$nextTick(() =>
    {
      

      this.isReady = true;
      setTimeout(() => {
        $('.carousel-3d-container')[0].style.height = '144px';
        $('.carousel-3d-slider')[0].style.height = '142px';
        $('.carousel-3d-slider')[0].style.width = '196px';
        $('.carousel-3d-slide').height(140);
        $('.carousel-3d-slide').width(196);

        //console.log(this.product.partsPalettes.length);
        if (this.product.partsPalettes.length === 1)
        {
          //console.log("only 1 part")
          $('.carousel-3d-controls')[0].style.display = 'none';
        }

        //console.log($('.carousel-3d-slider'));

      }, 100);
    });
  }

  colorChangedByAccList(col: any,pal: any) {
    this.selectedColor = col;
    this.selectedPallate = pal;
    this.$emit('colorChanged',this.selectedColor,this.selectedPallate,this.selectedPart);
  }

  getSelectedColor(selectedPart)
  {
    if (!Store.state.selection)
    {
      return "";
    }
    const getPart = Store.state.selection.parts.find(x => x.id === selectedPart);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === getPart.palette);
    const getColor = getPalettes.colors.find(col => col.name === getPart.color);
    return getColor.displayName;
  }
}



// WEBPACK FOOTER //
// ./src/components/partsColor/PartsColor.ts